/**
 * Type Breakdown Chart Component
 * Simple bar chart for request type distribution
 */

import React from 'react';

export default function TypeBreakdownChart({ typeBreakdown }) {
  if (!typeBreakdown || typeBreakdown.length === 0) {
    return (
      <div className="text-center py-12 text-gray-500">
        No type breakdown data available
      </div>
    );
  }

  // Sort by volume and take top 10
  const sortedTypes = [...typeBreakdown]
    .sort((a, b) => b.tickets_30d - a.tickets_30d)
    .slice(0, 10);

  const maxValue = Math.max(...sortedTypes.map((t) => t.tickets_30d));

  const priorityColors = {
    urgent: 'bg-red-500',
    high: 'bg-orange-500',
    medium: 'bg-yellow-500',
    low: 'bg-blue-500',
  };

  return (
    <div className="space-y-3">
      {sortedTypes.map((type, index) => {
        const pct = (type.tickets_30d / maxValue) * 100;
        return (
          <div key={index} className="space-y-1">
            <div className="flex items-center justify-between text-xs">
              <span className="font-medium text-gray-700">
                {type.request_type.replace('_', ' ')} ({type.priority})
              </span>
              <span className="text-gray-600">{type.tickets_30d} tickets</span>
            </div>
            <div className="h-6 bg-gray-100 rounded overflow-hidden">
              <div
                className={`h-full ${priorityColors[type.priority] || 'bg-gray-500'}`}
                style={{ width: `${pct}%` }}
              ></div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
